export default "__VITE_ASSET__B4k16Pxp__"